// extracted by mini-css-extract-plugin
export default {"wrapper":"OCRq_4"};